import MitzvotList from '../components/Mitzvot/MitzvotList';

/**
 * Página de Comparativa de Mandamientos
 * Renderiza el componente principal de lista de mandamientos
 */
export default function ComparativaMandamientos() {
  return <MitzvotList />;
}
